<template>
  <div>
    <!-- 头部 -->
    <header class="common-header">
      <div class="left">
        <div>
          <el-select v-model="parameter.searchType" size="medium" style="width:110px;" class="rightBorderNone">
            <el-option label="SPU" :value="1" />
            <el-option label="商品名称" :value="2" />
          </el-select>
          <el-popover placement="bottom" width="400" trigger="click" v-if="parameter.searchType === 1" style="margin-right:10px">
            <el-input v-model="parameter.searchNameArrays" size="medium" placeholder="支持批量搜索" style="width:250px" clearable @change="getProductList" slot="reference">
              <el-button slot="append" icon="el-icon-search" @click="searchGetProductList"></el-button>
            </el-input>
            <el-input v-model="parameter.searchNameArrays" placeholder="支持批量搜索" size="medium" type="textarea" style="width:100%" clearable @change="getProductList" :rows="6"></el-input>
          </el-popover>
          <el-input v-model="parameter.searchNameArrays" size="medium" placeholder="输入商品名称" style="width:270px;margin-right:10px" clearable @change="getProductList" v-if="parameter.searchType === 2">
            <el-button slot="append" icon="el-icon-search" @click="getProductList"></el-button>
          </el-input>
          <el-select v-model="parameter.dateType" size="medium" style="width:100px" class="rightBorderNone">
            <el-option :value="3" label="上架时间"></el-option>
            <el-option :value="2" label="更新时间"></el-option>
            <el-option :value="1" label="新增时间"></el-option>
          </el-select>
          <el-date-picker v-model="addDate" type="datetimerange" size="medium" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" @change="changeDatePicker" style="width:350px;margin-right:10px" />
          <el-cascader placeholder="请选择品类" size="medium" :options="categoryOptions" :props="{ multiple: true, value: 'categoryId', label: 'name', children: 'childList', emitPath: false }" :show-all-levels="false" filterable collapse-tags clearable v-model="categoryValue" @change="selectCategory" style="width: 260px;margin-right:12px">
            <template slot-scope="{ node, data }">
              <span>{{ data.name }}</span>
              <span v-if="!node.isLeaf"> ({{ data.childList.length }}) </span>
            </template>
          </el-cascader>
          <el-select v-model="parameter.status" size="medium" clearable placeholder="产品状态" style="width:100px;margin-right:10px" @change="getProductList">
            <el-option label="在售" :value="1" />
            <el-option label="缺货" :value="4" />
            <el-option label="下架" :value="0" />
          </el-select>
          <el-select v-model="parameter.virtualWarehouseId" size="medium" clearable placeholder="商品分组" @change="getProductList" style="width:160px;margin-right:12px">
            <el-option v-for="item in virtualWarehouse" :key="item.id" :label="item.virtualWarehouseName" :value="item.id" />
          </el-select>
          <el-select v-model="parameter.supplierLevels" size="medium" multiple collapse-tags clearable placeholder="供应商等级" style="width:120px;margin-right:10px" @change="getProductList">
            <el-option label="A" :value="1" />
            <el-option label="B" :value="2" />
            <el-option label="C" :value="3" />
            <el-option label="无等级" :value="999" />
          </el-select>
          <el-button @click="clickDropdownItem(5)">导出</el-button>
            <el-button @click="showDialog">列表字段配置</el-button>
        </div>
        <!-- <div class="f-b-c" style="margin-top:10px">
          <div></div>
          <div>
            <el-button @click="clickDropdownItem(5)">导出</el-button>
            <el-button @click="showDialog">列表字段配置</el-button>
          </div>
        </div> -->
      </div>
    </header>
    <div class="errorType f f--c" v-if="tabType === 3">
      <span style="margin-right: 8px;font-size:15px">异常类型:</span>
      <el-button v-for="item in errorTypeList" :key="item.name" type="text" @click="errorTypeClick(item)" :class="{ errorTypeActive: parameter.errorType === item.type }">{{ `${item.name}(${item.total})` }}</el-button>
    </div>

    <!-- 主体 -->
    <section class="common-section">
      <el-table :data="productData" v-loading="loading" height="100%" @selection-change="handleSelectionChange" @sort-change="tableSortChange" :row-key="tableRowKey" lazy :load="dataChildrenLoad" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
        <el-table-column type="selection" :min-width="50" />
        <el-table-column label="商品信息" :min-width="400">
          <template slot-scope="{ row }">
            <el-popover placement="right" width="280" trigger="hover">
              <el-image :src="row.images" fit="cover" />
              <el-image slot="reference" :src="row.images" fit="cover" class="stock-img" />
            </el-popover>
            <div style="display: inline-block;margin-left: 10px">
              <el-tooltip v-if="row.productName" class="item" effect="dark" :content="row.productName" placement="top-start">
                <div class="ellipsis">标题: {{ row.productName }}</div>
              </el-tooltip>
              <div v-if="row.name" class="ellipsis">品类: {{ row.name ? row.name : '-' }}</div>
              <div v-if="row.spuCode">SPU: {{ row.spuCode }}</div>
              <div v-if="row.skuCode">SKU: {{ row.skuCode }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="商品状态" :min-width="150">
          <div slot-scope="{ row }" class="status f-c-c" :style="{ border: row.status === 1 ? '1px solid #99C41C' : row.status === 0 ? '1px solid #f07a7a' : row.status === 4 ? '1px solid #ffd400' : ''}">
            <div class="left" :style="{ background: row.status === 1  ? '#99C41C' : row.status === 0 ? '#f07a7a' : row.status === 4 ? '#ffd400' : '' }"></div>
            <div>{{ row.status == 1  ? '在售' : row.status == 0 ? '下架' : row.status == 4 ? "缺货" : "" }}</div>
          </div>
        </el-table-column>
        <el-table-column label="评论" :min-width="100" :align="'center'">
          <template slot-scope="{ row }">
            <div class="f-c-c" >
              <span class="ellipsis pointer" style="color: #99C41C" :title="row.reviewCount" v-text="row.reviewCount" @click="viewReview(row)" />
            </div>
          </template>
        </el-table-column>
        <el-table-column v-for="(item,index) in columns" :key="index" :sortable="item.sort" :prop="item.value" :label="item.title" :min-width="item.width">
          <template v-if="item.isTip" slot="header">
            <el-tooltip class="item" effect="dark" :content="item.tip" placement="top">
              <div>{{item.title}}<i class="el-icon-question" style="margin-left:5px"></i></div>
            </el-tooltip>
          </template>
          <template slot-scope="{row}">
            <span v-if="item.title === '时间'"> 
              <div>新增时间:{{ moment(row.createDate).format('YYYY-MM-DD HH:mm:ss') }}</div>
              <div>更新时间:{{ moment(row.modifyDate).format('YYYY-MM-DD HH:mm:ss') }}</div>
              <div v-if="!row.skuCode && (row.status === 1 || row.status === 4)">上架时间:{{ row.upDate ? moment(row.upDate).format('YYYY-MM-DD HH:mm:ss') : '' }}</div>
            </span>
            <span v-else-if="item.title === '供应商等级'">
              {{ row.supplierLevel === 1 ? 'A' : row.supplierLevel === 2 ? 'B' : row.supplierLevel === 3 ? 'C' : '' }}
            </span>
            <span v-else> {{row[item.value]}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="virtualWarehouseName" label="商品分组" width="150"></el-table-column>
        <el-table-column label="供应商等级" width="100">
          <template slot-scope="{ row }">
            {{ row.supplierLevel === 1 ? 'A' : row.supplierLevel === 2 ? 'B' : row.supplierLevel === 3 ? 'C' : '' }}
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="cost" label="总销量"></el-table-column>
        <el-table-column label="成本价$" prop="cost">
          <template slot="header">
            <el-tooltip class="item" effect="dark" content="开发建议成本价 ¥ * 汇率 6.3" placement="top">
              <div>成本价<i class="el-icon-question" style="margin-left:5px"></i></div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="售价$" prop="price">
          <template slot="header">
            <el-tooltip class="item" effect="dark" content="成本价 * 费率 1.3" placement="top">
              <div>售价<i class="el-icon-question" style="margin-left:5px"></i></div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="realStockList" label="实际库存" sortable="custom">
          <template slot-scope="{ row }">
            <el-popover placement="button" width="380" trigger="click" v-if="row.skuCode">
              <el-table :data="row.realStockList">
                <el-table-column property="wareHouseName" label="仓库名称" />
                <el-table-column property="realStockNum" label="实际总库存" width="100" />
              </el-table>
              <span slot="reference" style="color: #99c41c;cursor: pointer;">{{ row.realStockTotal }}</span>
            </el-popover>
            <span v-else>{{ row.realStockTotal }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="virtualStockList" label="页面显示库存" sortable="custom">
          <template slot-scope="{ row }">
            <el-popover v-if="row.skuCode" placement="button" width="380" trigger="click">
              <el-table :data="row.virtualStockList">
                <el-table-column property="wareHouseName" label="仓库名称" />
                <el-table-column property="virtualStockNum" label="虚拟总库存" width="100" />
              </el-table>
              <span slot="reference" style="color: #99c41c;cursor: pointer;">{{row.virtualStockTotal}}</span>
            </el-popover>
            <span v-else>{{ row.virtualStockTotal }}</span>
          </template>
        </el-table-column>
        <el-table-column label="重量(g)" prop="packageWeight"></el-table-column>
        <el-table-column prop="createDate" label="时间" sortable="custom" width="230">
          <template slot-scope="{ row }">
            <div>新增时间:{{ moment(row.createDate).format('YYYY-MM-DD HH:mm:ss') }}</div>
            <div>更新时间:{{ moment(row.modifyDate).format('YYYY-MM-DD HH:mm:ss') }}</div>
            <div v-if="!row.skuCode && (row.status === 1 || row.status === 4)">上架时间:{{ row.upDate ? moment(row.upDate).format('YYYY-MM-DD HH:mm:ss') : '' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="errorDescription" label="原因" v-if="tabType === 3"></el-table-column> -->

        <el-table-column label="操作" width="150">
          <template slot-scope="{ row }">
            <el-button type="text" size="medium" @click="() => handleEditGoods(row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>

    <!-- 页脚 -->
    <footer class="common-footer">
      <el-pagination background :current-page="parameter.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="parameter.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </footer>
    <!-- 加入专辑对话框 -->
    <el-dialog title="选择专辑" :visible.sync="albumDialogVisible" width="20%" :close="handleCloseAlbum">
      <el-input v-model="filterAlbumText" size="medium" clearable class="filter-album-text" placeholder="输入关键字进行过滤" />
      <div class="el-tree-box">
        <el-tree ref="albumTree" :filter-node-method="filterCategoryNode" :data="albumTreeData" :props="{ label: 'name', children: 'childList' }" show-checkbox default-expand-all node-key="shopWindowId" highlight-current />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseAlbum">取 消</el-button>
        <el-button type="primary" @click="handleOkAlbum">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 加入品类对话框 -->
    <el-dialog title="选择品类" :visible.sync="categoryDialogVisible" width="20%" :close="handleCloseCategory">
      <el-input v-model="filterCategoryText" size="medium" clearable class="filter-category-text" placeholder="输入关键字进行过滤" />
      <div class="el-tree-box">
        <el-tree ref="categoryTree" :filter-node-method="filterCategoryNode" :data="categoryOptions" :props="{ label: 'name', children: 'childList' }" default-expand-all node-key="categoryId" highlight-current>
          <template slot-scope="{ node, data }">
            <span>
              <el-radio v-if="isLast(data)" v-model="radios" :label="data.categoryId"><br /></el-radio>
              {{ node.label }}
            </span>
          </template>
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseCategory">取 消</el-button>
        <el-button type="primary" @click="handleOkCategory">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 列表字段配置对话框 -->
    <el-dialog title="列表字段配置" :visible.sync="visible" width="50%"  height="50%" @close="close" :close-on-click-modal="false">
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <div style="margin: 15px 0;"></div>
      <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
        <el-checkbox style="width:20%;margin-bottom:10px" v-for="(item,index) in columnTitles" :key="index" :label="item.value">{{item.title}}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import API from '@/api'
import XLSX from 'xlsx'
export default {
  props: {
    categoryOptions: {
      type: Array,
      default: () => []
    },
    virtualWarehouse: {
      type: Array,
      default: () => []
    },
    tabType: {
      type: Number,
      default: () => 1
    }
  },
  data() {
    let parameter = {
      searchNameArrays: undefined, // 搜索关键字
      startTime: undefined, // 开始添加时间
      endTime: undefined, // 结束添加时间
      status: undefined, // 上架状态：0.下架 1.上架
      categoryIds: undefined, // 品类id集合
      sortType: undefined, // 排序字段：1.销量 2.实际库存 3.虚拟库存 4.新增时间
      sort: undefined, // 排序的类型：asc升序 desc降序
      allVirtualWarehouseId: 1, //过滤所有虚拟仓，返回所有商品
      pageNumber: 1, // 当前页
      pageSize: 20, // 每日显示条数
      errorType: undefined,
      dateType: 3,
      searchType: 1,
      lockIng: undefined // TODO 是否覆盖
    }
    return {
      moment: moment, // 处理日期插件
      addDate: undefined, // 筛选 - 日期选择器绑定的值
      upperOrLowerShelfParameter: {
        // 上架或者下架请求参数
        kkProductIds: [], // ids数组
        status: undefined // 0.下架 1.上架
      },
      loading: false,
      parameter: { ...parameter, tabType: this.tabType }, // 表格数据请求参数
      productData: [], // 表格数据源
      kkProductIds: [], // 表格复选框当前选中行的id数组
      total: 0, // 分页总数
      filterAlbumText: undefined, // 加入专辑对话框 - 过滤搜索框绑定的值
      albumDialogVisible: false, // 加入专辑对话框 - 是否显示加入专辑Dialog
      albumTreeData: [], // 加入专辑对话框 - Tree树形组件的数据源
      radios: undefined, // 加入品类材质树形结构单选框选中的值
      filterCategoryText: undefined, // 加入品类对话框 - 过滤搜索框绑定的值
      categoryDialogVisible: false, // 加入品类对话框 - 是否显示Dialog
      visible: false, // 列表字段配置弹框 - 是否显示Dialog
      checkAll: false, // 列表字段配置弹框 - 是否全选
      isIndeterminate: true,
      columns: [
        { title: '商品分组', value: 'virtualWarehouseName', width: 150, check: true , sort: false, isTip: false, tip: '' },
        { title: '供应商等级', value: 'supplierLevel', width: 100, check: true , sort: false, isTip: false, tip: '' },
        { title: '总销量', value: 'salesVolumeQty', width: 100, check: true , sort: true, isTip: false, tip: '' },
        { title: '成本价($)', value: 'cost',  width: 120, check: true , sort: false, isTip: true, tip: '开发建议成本价 ¥ * 汇率 6.3' },
        { title: '售价($)', value: 'price', width: 120, check: true, sort: false, isTip: true, tip: '成本价 * 费率 1.3' },
        // { title: '实际库存', value: 'realStockTotal', width: 120, check: true, sort: 'custom', isTip: false, tip: '' },
        { title: '页面显示库存', value: 'virtualStockTotal', width: 150,  check: true , sort: 'custom', isTip: false, tip: '' },
        { title: '重量(g)', value: 'packageWeight', width: 100,  check: true , sort: false, isTip: false, tip: '' },
        { title: '时间', value: 'createDate', width: 230, check: true , sort: 'custom', isTip: false, tip: '' },
      ],
      checkList: [], // 列表字段配置显示数组
      columnTitles: [
        { title: '商品分组', value: 'virtualWarehouseName', width: 150, check: true , sort: false, isTip: false, tip: '' },
        { title: '供应商等级', value: 'supplierLevel', width: 100, check: true , sort: false, isTip: false, tip: '' },
        { title: '总销量', value: 'salesVolumeQty', width: 100, check: true, sort: true, isTip: false, tip: '' },
        { title: '成本价($)', value: 'cost', width: 120, check: true , sort: false, isTip: true, tip: '开发建议成本价 ¥ / 汇率 6.3' },
        { title: '售价($)', value: 'price', width: 120, check: true , sort: false, isTip: true, tip: '成本价 * 费率 1.3' },
        // { title: '实际库存', value: 'realStockTotal', width: 120, check: true, sort: 'custom', isTip: false, tip: '' },
        { title: 'G007库存', value: 'g007', width: 120, check: false , sort: false, isTip: true, tip: '东莞-咔咔平台' },
        { title: 'H008库存', value: 'h008', width: 120, check: false , sort: false, isTip: true, tip: 'H008咔咔美国仓' },
        { title: 'G009库存', value: 'g009', width: 120, check: false , sort: false, isTip: true, tip: 'FBA-TikTok(虚拟)仓' },
        { title: 'USLAX1库存', value: 'uslax1', width: 120, check: false , sort: false , isTip: true, tip: '易仓-美国仓'},
        { title: '页面显示库存', value: 'virtualStockTotal', width: 150,  check: 'custom' , sort: true, isTip: false, tip: '' },
        { title: '重量(g)', value: 'packageWeight', width: 100,  check: true , sort: false, isTip: false, tip: '' },
        { title: '时间', value: 'createDate', width: 230, check: true , sort: 'custom' , isTip: false, tip: ''},
      ],
      backUpColumn: [], // 后台返回的已选列表
      categoryValue: [],
      errorTypeList: [],
      selectedParam: undefined,
    }
  },
  computed: {
    isLast() {
      return (data) => {
        return this.checkIsLast(data)
      }
    }
  },
  watch: {
    filterCategoryText(value) {
      this.$refs.categoryTree.filter(value)
    },
    filterAlbumText(value) {
      this.$refs.albumTree.filter(value)
    }
  },
  created() {
    if (this.tabType === 3) this.productGetErrorType()
    this.getBehaviorConfig()
  },
  methods: {
    checkIsLast(data) {
      if (!data.childList) {
        return true
      } else {
        this.checkIsLast(data.childList)
      }
    },

    // 获取商品列表
    async getProductList(call = true) {
      try {
        this.loading = true
        if (call) this.resetPage()
        let newParameter = { ...this.parameter, tabType: this.tabType }
        newParameter.searchNameArrays = newParameter.searchNameArrays ? newParameter.searchNameArrays.split('\n') : undefined
        this.$store.commit('setState', { key: 'goodsGetListParams', value: newParameter })
        let { data } = await API.getProductList(newParameter)
        this.total = data.total
        this.productData = data.list.map(item => ({
          ...item,
          children: [],
          hasChildren: true,
          newStatus: item.status
        }))
        this.loading = false
      } catch (error) {
        this.loading = false
        throw new Error(error.message)
      }
      this.$tableScrollTop()
    },

    // 搜索列表
    searchGetProductList() {
      this.productData = []
      this.getProductList()
    },
    resetPage() {
      this.parameter.pageNumber = 1
    },

    // 获取品类列表
    async getCategoryList() {
      let { data } = await API.getCategoryList({ pageNumber: 1, pageSize: 1000 })
      if (data && data.list.length) {
        this.deletechildList(data.list)
        this.categoryOptions = data.list
      }
    },
    deletechildList(arr) {
      // 删除最后一级为空的childList字段
      arr.forEach((item) => {
        if (!item.childList.length) {
          delete item.childList
        } else {
          this.deletechildList(item.childList)
        }
      })
    },
    

    // 获取专辑列表
    async getAlbumList() {
      let { data } = await API.getAlbumList({ pageNumber: 1, pageSize: 1000 })
      if (data && data.list.length) {
        this.deletechildList(data.list)
        this.albumTreeData = data.list
      }
    },

    // 添加商品
    addGoods() {
      this.$router.push('/supply/goods/goods')
    },

    // 筛选 - 日期选择器确认选定的值时触发的回调
    changeDatePicker(value) {
      if (value && value.length === 2) {
        this.parameter.startTime = value[0]
        this.parameter.endTime = value[1]
      } else {
        this.parameter.startTime = undefined
        this.parameter.endTime = undefined
      }
      this.getProductList()
    },

    // 筛选 - 选择活动区域下拉框选中值发生变化时的回调
    selectRegion(value) {
      if (value || value === 0) {
        this.parameter.status = value
      } else {
        this.parameter.status = undefined
      }
      this.getProductList()
    },

    // 导出上架失败原因
    async exportShelfFailureReason(taskType) {
      let newParameter = { ...this.parameter, kkProductIds: this.kkProductIds }
      newParameter.searchNameArrays = newParameter.searchNameArrays ? (newParameter.searchNameArrays.includes(',') ? newParameter.searchNameArrays.split(',') : newParameter.searchNameArrays.split('\n')) : undefined
      delete newParameter.pageNumber
      delete newParameter.pageSize
      let taskTypeType = Object.prototype.toString.call(taskType).slice(8, -1)
      API.importExportFile({ fileType: 2, taskType: taskTypeType === 'Number' ? taskType : 4, condition: JSON.stringify(newParameter) }).then(() => {
        this.$message.success('用户数据导出成功,请前往导入导出中心查看进度')
      })
    },
    sheet2blob(sheet, sheetName) {
      sheetName = sheetName || 'sheet1'
      var workbook = {
        SheetNames: [sheetName],
        Sheets: {}
      }
      workbook.Sheets[sheetName] = sheet
      // 生成excel的配置项
      var wopts = {
        bookType: 'xlsx', // 要生成的文件类型
        bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
        type: 'binary'
      }
      var wbout = XLSX.write(workbook, wopts)
      var blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' })
      function s2ab(s) {
        var buf = new ArrayBuffer(s.length)
        var view = new Uint8Array(buf)
        for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
        return buf
      }
      return blob
    },

    // 筛选 - 商品品类级联选择器选中值发生变化时的回调
    selectCategory(value) {
      if (!value.length) {
        this.parameter.categoryIds = undefined
      } else {
        this.parameter.categoryIds = value
      }
      this.getProductList()
    },

    // 批量操作 - 点击菜单项触发的事件回调
    async clickDropdownItem(command) {
      switch (command) {
        case 1: // 上架
          this.upperOrLowerShelfParameter.status = 1
          this.upperOrLowerShelfParameter.kkProductIds = this.kkProductIds
          this.upperOrLowerShelf()
          break
        case 2: // 下架
          this.upperOrLowerShelfParameter.status = 0
          this.upperOrLowerShelfParameter.kkProductIds = this.kkProductIds
          this.upperOrLowerShelf()
          break
        case 6: // 停售
          this.upperOrLowerShelfParameter.status = 3
          this.upperOrLowerShelfParameter.kkProductIds = this.kkProductIds
          this.upperOrLowerShelf()
          break
        case 7: // 缺货
          this.upperOrLowerShelfParameter.status = 4
          this.upperOrLowerShelfParameter.kkProductIds = this.kkProductIds
          this.upperOrLowerShelf()
          break
        case 3: // 加入专辑
          this.getAlbumList()
          this.albumDialogVisible = true
          break
        case 4: // 加入品类
          this.categoryDialogVisible = true
          break
        case 5:
          this.exportShelfFailureReason(9)
          break
      }
    },
    async upperOrLowerShelf(row, value) {
      // 批量操作 - 上架/下架
      let result = await API.upperOrLowerShelf(this.upperOrLowerShelfParameter)
      if (result.code === 10000) {
        if (value || value === 0) this.$set(row, 'status', value)
        this.getProductList(false)
        this.$message.success(result.message)
      } else {
        this.$set(row, 'newStatus', row.status)
        this.$message.error(result.message)
      }
      this.upperOrLowerShelfParameter.status = undefined
      this.upperOrLowerShelfParameter.kkProductIds = []
    },

    // 当表格复选框选择项发生变化时会触发该事件
    handleSelectionChange(selection) {
      this.kkProductIds = selection.map((item) => item.kkProductId)
    },

    // 当表格的排序条件发生变化的时候会触发该事件
    tableSortChange({ prop, order }) {
      if (order === 'ascending') {
        // 升序
        if (prop === 'salesVolumeQty') {
          // 总销量
          this.parameter.sortType = 1
        } else if (prop === 'realStockTotal') {
          // 实际库存
          this.parameter.sortType = 2
        } else if (prop === 'virtualStockTotal') {
          // 页面显示库存
          this.parameter.sortType = 3
        } else if (prop === 'createDate') {
          // 新增时间
          this.parameter.sortType = 4
        }
        this.parameter.sort = 'asc'
      } else if (order === 'descending') {
        // 降序
        if (prop === 'salesVolumeQty') {
          // 总销量
          this.parameter.sortType = 1
        } else if (prop === 'realStockTotal') {
          // 实际库存
          this.parameter.sortType = 2
        } else if (prop === 'virtualStockTotal') {
          // 页面显示库存
          this.parameter.sortType = 3
        } else if (prop === 'createDate') {
          // 新增时间
          this.parameter.sortType = 4
        }
        this.parameter.sort = 'desc'
      } else {
        // null表示还原为原始顺序
        this.parameter.sortType = undefined
        this.parameter.sort = undefined
      }
      this.getProductList()
    },

    //  上架状态开关发生变化时的回调
    async changeSwitch(row, value) {
      if (!row.hasChildren) {
        this.editSkuStatus(row, value)
        return
      }
      this.upperOrLowerShelfParameter.status = value
      this.upperOrLowerShelfParameter.kkProductIds = [row.kkProductId]
      this.upperOrLowerShelf(row, value)
    },

    // 编辑
    handleEditGoods(row) {
      this.$router.push({ path: '/supply/goods/goods', query: { id: row.kkProductId } })
    },

    // 每页显示条数改变时的回调
    handleSizeChange(value) {
      this.parameter.pageSize = value
      this.getProductList(false)
    },

    // 当前页发生改变时触发的回调
    handleCurrentChange(value) {
      this.parameter.pageNumber = value
      this.getProductList(false)
    },

    // 加入品类对话框 - 根据关键字过滤的方法
    filterCategoryNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },

    // 加入专辑对话框 - Dialog关闭的回调
    handleCloseAlbum() {
      this.albumDialogVisible = false
      this.filterAlbumText = undefined
      this.$refs.albumTree.setCheckedKeys([])
    },

    // 加入专辑对话框 - Dialog确定的回调
    async handleOkAlbum() {
      let result = await API.addAlbum({ kkProductId: this.kkProductIds, shopWindowId: this.$refs.albumTree.getCheckedKeys(true) })
      if (result.code === 10000) {
        this.getProductList(false)
        this.albumDialogVisible = false
        this.$message.success(result.message)
      } else {
        this.$message.error(result.message)
      }
    },

    // 加入品类对话框 - Dialog关闭的回调
    handleCloseCategory() {
      this.radios = undefined
      this.categoryDialogVisible = false
      this.filterCategoryText = undefined
    },

    // 加入品类对话框 - Dialog确定的回调
    async handleOkCategory() {
      if (!this.radios) {
        return this.$message.warning('请选择材质')
      }
      let result = await API.addCategory({ kkProductId: this.kkProductIds, categoryId: [this.radios] })
      if (result.code === 10000) {
        this.getProductList(false)
        this.categoryDialogVisible = false
        this.$message.success(result.message)
      } else {
        this.$message.error(result.message)
      }
    },
    getStorageParams() {
      const { searchNameArrays, startTime, endTime, categoryIds, ...other } = this.$store.state.goodsGetListParams
      this.parameter = Object.assign(this.parameter, other)
      if (searchNameArrays) this.parameter.searchNameArrays = searchNameArrays.join(',')
      if (startTime && endTime) this.addDate = [startTime, endTime]
      if (categoryIds) this.categoryValue = categoryIds
    },
    productGetErrorType() {
      API.productGetErrorType().then((res) => {
        const arr = []
        let otherTotal = 0
        let otherType = []
        res.data.forEach((e) => {
          if (['尺寸不完整', '重量为零', '成本为零', '售价为零', '材质不完整', '尺码不完整', '颜色不完整', '库存信息缺失', '商品名称信息缺失', 'sku没有主图', '商品停售'].includes(e.name)) {
            e.type = [e.type]
            arr.push(e)
          } else {
            otherTotal += e.total
            otherType.push(e.type)
          }
        })
        arr.push({ name: '其他', total: otherTotal, type: otherType })
        this.errorTypeList = arr
      })
    },
    errorTypeClick(item) {
      this.parameter.errorType = this.parameter.errorType === item.type ? undefined : item.type
      this.getProductList()
    },
    tableRowKey(record) {
      return record.spuCode ? `${record.kkProductId}${record.spuCode}` : `${record.kkProductId}${record.skuCode}`
    },
    dataChildrenLoad(tree, treeNode, resolve) {
      this.getChild(tree.kkProductId, this.tabType, resolve)
    },

    getChild(kkProductId, tabType, resolve) {
      API.productGetChildSku({ kkProductId, tabType }).then((res) => {
        resolve(res.data.map(item => ({ ...item, newStatus: item.status })))
      })
    },

    // 单个sku上下架
    editSkuStatus(row, value) {
      API.editSkuStatus({
        kkProductId: row.kkProductId,
        skus: [row.skuCode],
        status: value
      }).then((res) => {
        if (res.code !== 10000) {
          this.$set(row, 'newStatus', row.status)
          this.$message.error(res.message)
          return
        }
        this.$message.success(res.message)
        this.$set(row, 'status', value)
      })
    },
    showDialog() {
      this.visible = true,
      this.checkList = this.columns.map(item => item.value)
      this.backUpColumn = _.cloneDeep(this.checkList)
    },
    close() {
      this.checkList = _.cloneDeep(this.backUpColumn)
      this.visible = false
      let checkedCount = this.checkList.length;
      this.checkAll = checkedCount === this.columnTitles.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnTitles.length;
    },
    handleCheckAllChange(val) {
      this.checkList = val ? this.columnTitles.map(item => item.value) : []
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.columnTitles.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnTitles.length;
    },
    save() {
      this.columns = _.cloneDeep(this.columnTitles).filter(item => this.checkList.includes(item.value))
      // 获取选中的值
      this.selected = _.cloneDeep(this.columns).map(item => item.title)
      this.setBehaviorConfig()
      this.parameter.showFields = [...this.checkList, 'productInfo', 'status', 'virtualWarehouseName', 'supplierLevel']
      this.getProductList(false)
      this.backUpColumn = this.checkList
      this.visible = false
      this.$forceUpdate()
    },
    getBehaviorConfig() {
      // 获取全部商品的列表字段显示
      API.getBehaviorConfig(6).then((res) => {
        if (!res.data) return
        this.checkList = res.data.content
        this.columns = _.cloneDeep(this.columnTitles).filter(item => this.checkList.includes(item.title))
        this.configId = res.data.id
      })
    },
    setBehaviorConfig() {
      const params = {
          type: 6,
          content: JSON.stringify(this.selected),
          id: this.configId
      }
      API.setBehaviorConfig(params)
    },
    viewReview(row) {
      this.$router.push(`/supply/review?spuCode=${row.spuCode}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.common-header {
  // display: flex;
  width: 100%;
  height: 50px;
  align-items: center;
  .left {
    .el-input {
      width: 320px;
      .el-select {
        width: 100px;
      }
    }
    .rightBorderNone {
      margin-right: 0 !important;
      /deep/.el-input__inner {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right: none;
      }
    }
  }
}
.errorType {
  margin-top: 10px;
}

.common-section {
  height: calc(100vh - 294px);
  margin: 12px 0;
  .stock-img {
    width: 60px;
    height: 60px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #f5f7fa;
    user-select: none;
    cursor: pointer;
  }

  .status {
    width: 80px;
    height: 36px;
    border-radius: 40px;
    .left {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      margin-right: 6px;
    }
  }
}

.common-footer {
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: flex-end;
}
/deep/.el-input-group__prepend {
  background-color: #fff !important;
}
/deep/.el-table__expand-icon {
  transform: rotate(0deg);
  > .el-icon-arrow-right::before {
    content: '\e6d9';
    border: 1px solid #ccc;
    padding: 1px;
  }
}
/deep/.el-table__expand-icon--expanded {
  .el-icon-arrow-right::before {
    content: '\e6d8';
  }
}
.errorTypeActive {
  color: #909399;
}
/deep/.el-table__row--level-0 {
  > td:nth-of-type(2) {
    .cell {
      display: flex;
      align-items: center;
    }
  }
}
</style>
